import config from '@/assets/js/config'
import axios from '@/assets/libs/ajax'
import qs from 'qs';

let baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro;

export const getParamAPI = (data) => {
    let header = {};
    if (data.header) {
        if (data.header) {
            try {
                let headerJSON = JSON.parse(data.header);
                header = headerJSON;
            } catch (e) {
                header = {};
            }
        }
    }
    let post = '';
    if (data.postType === 1) {
        if (data.post) {
            try {
                let postJSON = JSON.parse(data.post);
                post = postJSON;
            } catch (e) {
                post = {};
            }
        }
    } else {
        post = data.post;
    }
    return axios.ajax({
        url: data.url,
        method: data.type,
        data: data.type === 'post' ? post : '',
        isNoQS: true,
        headers: header,
        token_key: true,
        isNoFFur: true
    })
};


